import { createSelector } from "reselect"

const thirdPartyApproval = state => state.thirdPartyApproval

export const selectApprovedAssets = createSelector(
  [thirdPartyApproval],
  thirdPartyApproval => thirdPartyApproval.approvedAssets
)
